// firebase.js
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
 
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDWKy2w98L_hmkMDhSNYym6gcRbwwAUp7E",
  authDomain: "retouchirm.firebaseapp.com",
  projectId: "retouchirm",
  //storageBucket: "retouchirm.firebasestorage.app",
  messagingSenderId: "568262640115",
  appId: "1:568262640115:web:57cf18f99243e7d1fe5286",
  measurementId: "G-3RDQ6YFD6K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// const db = getFirestore(app);

// Initialize Firebase Auth
const auth = getAuth(app);

//if (window.location.hostname === 'localhost') {
//  connectFirestoreEmulator(db, 'localhost', 8080);
//  }
  
// Export both app and auth
export { app, auth };


